import React from 'react';
import { Text, View } from '@react-pdf/renderer';

import { PDF_BLOCK_HEADING, PDF_BLOCK_TEXT, PDF_GRAY } from '../../../../constants';

const PdfTextBlock = ({ 
    fontNormal,
    fontSmaller,
    disableRightBorder,
    disableBottomBorder,
    disableLeftBorder,
    disableTopBorder,
    text,
    title,
    hideHeading, 
    hideText,
    titleStyles={},
    textStyles={}

 }) => {
    return (
        <View
            style={{
                flexGrow: "1",
                flexDirection: "row",
                width: "100%",
                borderWidth: "1px",
                borderColor: "#000",
                borderRightWidth: disableRightBorder ? "0" : "1px",
                borderLeftWidth: disableLeftBorder ? "0" : "1px",
                borderTopWidth: disableTopBorder ? "0" : "1px",
                borderBottomWidth: disableBottomBorder ? "0" : "1px",
            }}
        >
            
            <View
                style={{
                    flexShrink: 0,
                    width: "40%",
                    borderRightWidth: "1px",
                    borderColor: "#000",
                    backgroundColor: PDF_GRAY,
                    padding: "3px 3px",
                    justifyContent: "center"
                }}
            >
                <Text style={{
                    fontStyle: "italic",
                    fontSize: PDF_BLOCK_HEADING,
                    fontWeight: "400",
                    ...titleStyles
                }}>
                    {title ? title : "-"}
                </Text>
            </View>
            <View
                style={{
                    flexGrow: 1,
                    justifyContent: "center",
                    aligItems: "center",
                    maxWidth: "100%",
                    width: "100%",
                    padding: "5px 5px",
                    textAlign: "left",
                    backgroundColor: "#fff"
                }}
            >
                <Text style={{ fontSize: fontSmaller ? "8px" : PDF_BLOCK_TEXT, fontWeight: fontNormal ? "400" : "700", ...textStyles}}>
                    {text ? text : "-"}
                </Text>
            </View>
        </View>
    )
}

export default PdfTextBlock